import { formatNumbers } from "../../lens-stats/formatters";

export const formatNumericValue = (value: number): string => {
    if (value === 0) {
        return "-";
    }

    return formatNumbers(Math.round(value));
};
